import React, { createContext } from "react";
import { useEffect } from "react";
import { getData } from "../services/API";
import { useState } from "react";
import { getItemStorage } from "../Localstorage/useLocalStorage";

export const RefContextData = createContext();

const RefContext = ({ children }) => {
const [refCode, setRefCode] = useState("")

  return (
    <RefContextData.Provider value={{ refCode, setRefCode }}>
      {children}
    </RefContextData.Provider>
  );
};

export default RefContext;
